export default __webpack_public_path__ + "static/media/salesforce.f79d37a9.svg";